import type { PrivacyInfo, PrivacyTranslationKey } from '@/types/privacy-info';

export function getPrivacyTranslation(
    privacyInfo: PrivacyInfo | null | undefined,
    key: PrivacyTranslationKey
): string | null {
    if (!privacyInfo) return null;
    const value = privacyInfo.translations[key]?.trim();
    return value || null;
}
